import React, { memo } from 'react';
import { useI18n } from '../../../../i18n';
import S from './style/ActionCancellation';
import Shared from './style/Shared';

interface ActionCancellationProps {
  onClick: React.EventHandler<React.MouseEvent>;
  disabled?: boolean;
}

const ActionCancellation: React.FC<ActionCancellationProps> = function ActionCancellation({
  disabled,
  onClick,
}) {
  const i18n = useI18n();

  return (
    <Shared.OrderActions>
      <S.RejectButton data-cy="rejection-btn" as="a" disabled={disabled} onClick={onClick}>
        {i18n`dlv_orders_cancellation_confirm`}
      </S.RejectButton>
    </Shared.OrderActions>
  );
};

export default memo(ActionCancellation);
